var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "floatingButton-wrap", style: _vm.wrapStyle },
    [
      _c("div", { staticClass: "floatingButton-bg", style: _vm.bgStyle }, [
        _c(
          "button",
          {
            staticClass: "floatingButton",
            style: _vm.btnStyle,
            attrs: { type: "button" },
            on: { click: _vm.handleClick },
          },
          [_vm._v("\n      " + _vm._s(_vm.datas.btnText || "按钮") + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "deles-slot" }, [_vm._t("deles")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }